<template>
	<nut-navbar class="navbar" fixed :placeholder="false" :left-show="false">
		<template #left>
			<nut-avatar
				@click="handleControl('imhere')"
				size="small"
				:icon="currentDeviceData.device_icon"
			>
			</nut-avatar>
		</template>
		<template #content>
			<div
				v-show="currentDeviceData.device_name"
				@click="handleChangeCurrentDevice"
				class="select-title"
			>
				<div
					class="status-dot"
					:style="{
						backgroundColor:
							currentDeviceData.device_status ==
							DEVICE_STATUS.offline
								? '#e64340'
								: '#07c160',
					}"
				></div>
				<span>{{ currentDeviceData.device_name }}</span>
				<nut-icon
					class="icon-caret"
					class-prefix="icon"
					font-class-name="iconfont"
					name="caret-down"
				/>
			</div>
		</template>
		<template #right>
			<div class="settings" v-if="parseInt(currentDeviceData.device_id)">
				<nut-icon
					class="icon-setting"
					class-prefix="icon"
					font-class-name="iconfont"
					@click="handleNav"
					name="setting"
				>
				</nut-icon>
				<span class="txt">设置</span>
			</div>
		</template>
	</nut-navbar>
	<nut-navbar
		:class="['device-navbar', deviceListShow ? 'device-navbar__show' : '']"
		title="切换当前设备"
		fixed
		:placeholder="false"
		:left-show="false"
	>
		<template #right>
			<span class="btn-txt" @click="handleHideDeviceList">关闭</span>
		</template>
	</nut-navbar>
	<div class="main">
		<nut-swiper
			class="swiper"
			:init-page="page"
			:pagination-visible="true"
			pagination-color="#426543"
			auto-play="3000"
		>
			<nut-swiper-item
				:key="img.url"
				v-for="img in currentDeviceData.ad_list"
			>
				<img :src="img.url" alt="banner" />
			</nut-swiper-item>
		</nut-swiper>
		<div class="menu">
			<nut-grid :column-num="2">
				<nut-grid-item to="/upload" v-if="handleMenuVisible('upload')">
					<div class="menu-item">
						<span class="menu-title">媒体上传</span>
						<img
							class="menu-icon"
							src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/new1/11.png"
							alt=""
						/>
					</div>
				</nut-grid-item>
				<nut-grid-item
					to="/subtitle"
					v-if="handleMenuVisible('subtitle')"
				>
					<div class="menu-item">
						<span class="menu-title">字幕</span>
						<img
							class="menu-icon"
							src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/new1/16.png"
							alt=""
						/>
					</div>
				</nut-grid-item>
				<nut-grid-item to="/doodling" v-if="handleMenuVisible('doodling')">
					<div class="menu-item">
						<span class="menu-title">小黑板</span>
						<img
							class="menu-icon"
							src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/new1/15.png"
							alt=""
						/>
					</div>
				</nut-grid-item>
				<nut-grid-item to="/raffle" v-if="handleMenuVisible('raffle')">
					<div class="menu-item">
						<span class="menu-title">大转盘</span>
						<img
							class="menu-icon"
							src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/new1/7.png"
							alt=""
						/>
					</div>
				</nut-grid-item>
				<nut-grid-item to="/tts" v-if="handleMenuVisible('tts')">
					<div class="menu-item">
						<span class="menu-title">配音广播</span>
						<img
							class="menu-icon"
							src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/new1/10.png"
							alt=""
						/>
					</div>
				</nut-grid-item>
				<nut-grid-item
					to="/exchange"
					v-if="handleMenuVisible('exchange')"
				>
					<div class="menu-item">
						<span class="menu-title">游戏兑奖</span>
						<img
							class="menu-icon"
							src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/new1/3.png"
							alt=""
						/>
					</div>
				</nut-grid-item>
				<nut-grid-item v-if="handleMenuVisible('comingSoon')">
					<div class="menu-item">
						<span class="menu-title">敬请期待</span>
						<img
							class="menu-icon"
							src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/new1/9.png"
							alt=""
						/>
					</div>
				</nut-grid-item>
			</nut-grid>

			<img
				@click="popupVisible = true"
				class="control-icon"
				:class="[
					'control-icon',
					popupVisible ? 'control-icon__closed' : '',
				]"
				src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/new1/13.png"
				alt=""
			/>
			<help-text-tip
				style="margin: 10px 0"
				@click="handleOpenDialog(HOME_HElP)"
			></help-text-tip>
		</div>
	</div>

	<div :class="['device-list', deviceListShow ? 'device-list__show' : '']">
		<template v-if="deviceList.length">
			<div class="scrollContainer" id="infiniteList">
				<nut-infiniteloading
					containerId="infiniteList"
					:use-window="false"
					:is-open-refresh="true"
					:has-more="hasMore"
					@load-more="handleLoadMore"
					@refresh="handleRefresh"
					pull-icon="loading1"
					load-icon="loading1"
					load-more-txt="已经到底部啦～"
				>
					<div
						v-for="device in deviceList"
						:key="device.id"
						class="device-item"
						@click="handleSelectDevice(device.device_id)"
					>
						<nut-avatar
							size="small"
							shape="square"
							:icon="
								device.icon ||
								'https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/del_img/device_icon.png'
							"
						></nut-avatar>
						<span class="device-name">{{ device.name }}</span>
						<div class="status">
							<div
								class="status-dot"
								:style="{
									backgroundColor:
										device.status == DEVICE_STATUS.offline
											? '#e64340'
											: '#07c160',
								}"
							></div>
							<nut-icon
								v-if="device.on"
								:style="{ color: '#07c160', fontWeight: 700 }"
								class-prefix="icon"
								font-class-name="iconfont"
								name="duigou"
							></nut-icon>
							<span v-else style="width: 20px"></span>
						</div>
					</div>
				</nut-infiniteloading>
			</div>
		</template>
		<empty
			v-else
			text="暂无设备，请先激活和绑定设备！"
			@click="handleEmptyNav"
		/>
	</div>

	<nut-popup position="bottom" v-model:visible="popupVisible">
		<div class="pop-header">
			<h5>实时遥控</h5>
			<span @click="popupVisible = false" class="btn-close">关闭</span>
		</div>
		<div class="pop-content">
			<nut-grid :column-num="3" :border="false">
				<nut-grid-item @click="handleControl('previous')">
					<template #icon>
						<nut-icon
							class="arrow"
							class-prefix="icon"
							font-class-name="iconfont"
							name="verticalright"
							:size="24"
						>
						</nut-icon>
					</template>
					<template #text>
						<span class="nut-grid-item__text">上一个节目</span>
					</template>
				</nut-grid-item>
				<nut-grid-item @click="handleDeviceStatus">
					<template #icon>
						<img
							class="device-status"
							:src="
								currentDeviceData.device_status ==
								DEVICE_STATUS.offline
									? 'https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/new/on_f.png'
									: 'https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/new/on_o.png'
							"
						/>
					</template>
					<template #text>
						<span class="nut-grid-item__text">
							设备<span
								:style="{
									fontWeight: 600,
									color:
										currentDeviceData.device_status ==
										DEVICE_STATUS.offline
											? '#e64340'
											: '#07c160',
								}"
								>{{
									currentDeviceData.device_status ==
									DEVICE_STATUS.offline
										? '离线'
										: '在线'
								}}</span
							>
						</span>
					</template>
				</nut-grid-item>
				<nut-grid-item @click="handleControl('next')">
					<template #icon>
						<nut-icon
							class="arrow"
							class-prefix="icon"
							font-class-name="iconfont"
							name="verticalleft"
							:size="24"
						>
						</nut-icon>
					</template>
					<template #text>
						<span class="nut-grid-item__text">下一个节目</span>
					</template>
				</nut-grid-item>
			</nut-grid>
			<div class="voice-control">
				<nut-icon
					class-prefix="icon"
					font-class-name="iconfont"
					class="voice-icon"
					name="volume_close"
				></nut-icon>
				<nut-range
					v-model="voiceVal"
					hidden-range
					@drag-end="handleSlideDragover"
				>
				</nut-range>
				<nut-icon
					class-prefix="icon"
					font-class-name="iconfont"
					class="voice-icon"
					name="volume"
				></nut-icon>
			</div>
		</div>
	</nut-popup>

	<device-status
		v-model="deviceStatusVisible"
		:device-data="deviceInfo"
	></device-status>
	<notice-modal v-model="tipVisible" :tip="tip"></notice-modal>
</template>

<script>
import { reactive, toRefs, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { HelpTextTip, Empty } from '@/components';
import DeviceStatus from './components/deviceStatus.vue';
import NoticeModal from '@/components/noticeModal/notice.vue';
import useDialog from '@/hooks/useDialog';
import useNavigate from '@/hooks/useNavigate';
import { HOME_HElP } from '@/constants/tiptype';
import { homeApi, deviceApi } from '@/apis';
import { DEVICE_STATUS } from '@/constants';
import { Toast } from '@nutui/nutui';

const deviceLoadPageSize = 16;

export default {
	name: 'Home',
	components: {
		HelpTextTip,
		DeviceStatus,
		NoticeModal,
		Empty,
	},
	setup() {
		const store = useStore();
		const { push } = useNavigate();
		const { handleOpenDialog } = useDialog();
		const state = reactive({
			page: 0,
			popupVisible: false,
			voiceVal: 0,
			deviceListShow: false,
			deviceList: [],
			DEVICE_STATUS,
			currentDeviceData: {}, // 当前选择的设备数据
			deviceStatusVisible: false,
			deviceInfo: {},
			tipVisible: false,
			tip: {},
		});
		const hasMore = ref(true);
		const offset = ref(0);
		const locked = ref(false);

		const handleNav = () => {
			push('/setting');
		};

		const handleChangeCurrentDevice = async () => {
			await getDeviceList();
			state.deviceListShow = true;
		};

		const handleSelectDevice = async (deviceId) => {
			await homeApi.select_device({
				device_id: deviceId,
			});
			state.deviceListShow = false;
			getCurrentDeviceData();
		};

		const getDeviceList = async () => {
			locked.value = true;
			const list = await homeApi
				.load_device_list({
					offset: offset.value,
					limit: deviceLoadPageSize,
				})
				.finally(() => {
					locked.value = false;
				});
			state.deviceList =
				offset.value === 0 ? list : [...state.deviceList, ...list];
			hasMore.value = list.length >= deviceLoadPageSize;
		};

		const getCurrentDeviceData = async () => {
			const data = await homeApi.home_load_data();
			state.currentDeviceData = data;
			state.voiceVal = data.volume ? Number(data.volume) : 0;
			if (Array.isArray(data.tips) && data.tips.length) {
				state.tip = data.tips[0];
				state.tipVisible = true;
			}
			store.commit('device/setCurrentDeviceId', parseInt(data.device_id)); // 存储当前选择的设备
		};

		const handleDeviceStatus = async () => {
			// todo??? 两个接口是否有依赖顺序  在线情况每隔5s检查 状态交互逻辑？？？
			handleControl('kissme');
			getDeviceTask();
		};
		// 获取任务状态
		const getDeviceTask = async () => {
			Toast.loading('请求中...');
			const res = await homeApi.home_device_tasks();
			state.deviceInfo = res || {};
			state.deviceStatusVisible = true;
			Toast.hide();
		};

		const handleControl = async (action) => {
			const controlParam =
				typeof action === 'string' ? { action } : action;

			await deviceApi.device_command(controlParam);
		};

		const handleSlideDragover = async () => {
			handleControl({
				action: 'setvolume',
				value: state.voiceVal,
			});
		};

		const handleMenuVisible = (type) => {
			return (
				Array.isArray(state.currentDeviceData.menu) &&
				state.currentDeviceData.menu.includes(type)
			);
		};

		const handleRefresh = async (done) => {
			offset.value = 0;
			await getDeviceList();
			done();
		};

		const handleLoadMore = async (done) => {
			if (locked.value) return;
			offset.value = state.deviceList.length;
			await getDeviceList();
			done();
		};

		const handleHideDeviceList = () => {
			state.deviceListShow = false;
			state.deviceList = [];
			offset.value = 0;
		};

		const handleEmptyNav = () => {
			push('/activation');
		};

		onMounted(() => {
			getCurrentDeviceData();
			// getDeviceList();
		});

		return {
			HOME_HElP,

			...toRefs(state),
			handleNav,
			handleOpenDialog,
			handleChangeCurrentDevice,
			handleSelectDevice,
			handleControl,
			handleDeviceStatus,
			handleSlideDragover,
			handleMenuVisible,
			handleRefresh,
			handleLoadMore,
			handleHideDeviceList,
			handleEmptyNav,
			hasMore,
		};
	},
};
</script>

<style lang="scss" scoped>
.navbar {
	background: #fff;
	.settings {
		@include flex-column-center;
		font-size: $small-font-size;
		color: $primary-color;
	}
	.icon-setting {
		margin-bottom: 2px;
		font-size: $large-font-size;
		color: $primary-color !important;
	}

	.icon-caret {
		color: $base-font-color !important;
	}

	.txt {
		@include fontsize10;
	}

	.select-title {
		@include flex-center;
		color: $base-font-color;
	}
}

.main {
	margin-top: $navbar-height;
	padding-bottom: $tabbar-height;
}
.swiper {
	height: 240px;
}
.nut-swiper-item {
	height: 240px;
	img {
		width: 100%;
		height: 100%;
	}
}

.menu {
	&-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	&-title {
		width: 80px;
		font-size: 16px;
	}
	&-icon {
		width: 70px;
	}
}
.control-icon {
	position: fixed;
	bottom: 80px;
	width: 60px;
	height: 60px;
	right: 20px;
	text-align: center;
	opacity: 1;
	z-index: 101;
	transition: 0.35s;

	&__closed {
		right: -20px;
		opacity: 0;
	}
}
.pop-header {
	background: #f4f5f6;
	height: 32px;
	line-height: 32px;
	font-size: 14px;
	text-align: center;
	.btn-close {
		position: absolute;
		right: 8px;
		top: 0;
		color: $primary-color;
	}
}
.pop-content {
	padding: 16px;
	.device-status {
		width: 36px;
		height: 36px;
	}
	.arrow {
		color: $primary-color;
	}
	.voice-control {
		margin-top: 10px;
		@include flex-center;
		.voice-icon {
			margin: 0 18px;
			font-size: 20px;
		}
	}
}

.help {
	text-align: center;
	padding-top: 10px;
	font-size: 12px;
	color: #8b8b8b;
}

/** 设备列表 */
.device-navbar {
	z-index: -9 !important;
	opacity: 0;
	margin-bottom: 0;
	background: $primary-color;
	:deep(.nut-icon) {
		color: #fff !important;
		font-weight: 600;
	}
	:deep(.title) {
		color: #fff;
		font-weight: 500;
	}
	.btn-txt {
		color: #fff;
	}
	&__show {
		z-index: 9999 !important;
		opacity: 1;
	}
}
.device-list {
	position: fixed;
	bottom: 0;
	z-index: -9;
	width: 100%;
	height: 0;
	transition: 0.3s;
	z-index: 100;
	background: #fff;

	.device-item {
		padding: 16px 12px;
		border-bottom: 1px solid #f5f6f7;
		@include flex-center;

		.status {
			@include flex-center;
			.check {
				margin-left: 10px;
			}
		}
		.device-name {
			flex: 1;
			margin-left: 8px;
			text-align: left;
			font-size: 14px;
		}
	}
}

.device-list__show {
	height: calc(100vh - $navbar-height);
	z-index: 999;
	overflow-y: scroll;
}

.scrollContainer {
	height: calc(100vh - $navbar-height);
	overflow-y: scroll;
	overflow-x: hidden;
	:deep(.nut-infiniteloading) {
		height: 100%;
	}
}
</style>
